__turbopack_context__.v({
  "banner": "Optimize-module__kWZ4Aq__banner",
  "bottomNote": "Optimize-module__kWZ4Aq__bottomNote",
  "bottomNoteBar": "Optimize-module__kWZ4Aq__bottomNoteBar",
  "content": "Optimize-module__kWZ4Aq__content",
  "heroBuyNowButton": "Optimize-module__kWZ4Aq__heroBuyNowButton",
  "overlay": "Optimize-module__kWZ4Aq__overlay",
  "section": "Optimize-module__kWZ4Aq__section",
  "separator": "Optimize-module__kWZ4Aq__separator",
  "stack": "Optimize-module__kWZ4Aq__stack",
  "title": "Optimize-module__kWZ4Aq__title",
  "visual": "Optimize-module__kWZ4Aq__visual",
});
